// EmbedContext — where is this simulator mounted?
//
// "slide" — inside a module slide (drill, narrow content area). The
//           help overlay is suppressed: no "?" trigger, no auto-
//           welcome card. Slides already document the panel
//           verbosely; the help dialog is a Lab-scale feature and
//           overflows the slide content area.
// "lab"  — inside the Equipment Lab single-sim view (full canvas).
//           Full help layer: "?" button, welcome card on first
//           mount, hotspots, keyboard cheat card.
//
// Default is "slide" so the help layer stays opt-in for the Lab and
// any future surface that explicitly opts in. The Lab wraps its
// body in <EmbedContextProvider value="lab"> exactly once.

import { createContext, useContext, type ReactNode } from "react";

export type EmbedContextValue = "slide" | "lab";

const EmbedContext = createContext<EmbedContextValue>("slide");

interface ProviderProps {
  value: EmbedContextValue;
  children: ReactNode;
}

export function EmbedContextProvider({ value, children }: ProviderProps) {
  return <EmbedContext.Provider value={value}>{children}</EmbedContext.Provider>;
}

export function useEmbedContext(): EmbedContextValue {
  return useContext(EmbedContext);
}
